module.exports = __webpack_public_path__ + "img/email-cogs.0ce69aa6.svg";